import { Redirect, Route, Switch } from "react-router-dom";
import { AlertsPage } from "pages/AlertsPage";
import { ArchivedAlertsPage } from "pages/ArchivedAlertsPage";
import { RuleManagementPage } from "pages/RuleManagementPage";
import { AlertsProvider } from "contexts/AlertFiltersContext";

export const AlertRoutes = (): JSX.Element => {
  return (
    <AlertsProvider>
      <Switch>
        <Route exact path="/pages/alerts" component={AlertsPage} />
        <Route
          exact
          path="/pages/alerts/archived"
          component={ArchivedAlertsPage}
        />
        <Route
          exact
          path="/pages/alerts/rule-management"
          component={RuleManagementPage}
        />

        {/* Redirect to the closest exact path above when an incorrect url is entered*/}
        <Redirect to="/pages/alerts/archived" from="/pages/alerts/archived" />
        <Redirect
          to="/pages/alerts/rule-management"
          from="/pages/alerts/rule-management"
        />
        <Redirect to="/pages/alerts" from="/pages/alerts" />
        <Redirect to="/pages" />
      </Switch>
    </AlertsProvider>
  );
};
